// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".process-name[data-v-09d3452d]{font-size:1.2rem}.plus-minus-btn[data-v-09d3452d]{height:30px}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/manufactures/ManufactureOrderIndividualInfoShowPage.vue"],"names":[],"mappings":"AACA,+BACC,gBAAA,CAED,iCACC,WAAA","file":"ManufactureOrderIndividualInfoShowPage.vue","sourcesContent":["\n.process-name {\n\tfont-size: 1.2rem;\n}\n.plus-minus-btn {\n\theight: 30px;\n}\n"]}]);
// Exports
module.exports = exports;
